import { compose } from 'redux';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import * as vmSavedDashboardActions from '@store/viewerModule/dashboard/actions';
import { initTempDashboard } from '@store/viewerModule/tempDashboard/actions';
import tempDashboardSelector from '@store/viewerModule/tempDashboard/selectors';
import { dashboardResponseSelector, dashboardIsFetchingSelector } from '@store/viewerModule/dashboard/selectors';
import { DASHBOARD_TYPE, PAGE_TYPE } from '@utils/constants';
import dashboard from '../../common/dashboard';
import VMDashboard from '../index';
import injectorServer from '../../common/injectorServer';

const selectors = createSelector(
  dashboardResponseSelector,
  dashboardIsFetchingSelector,
  tempDashboardSelector,
  (response, isFetching, tempDashboard) => ({
    response,
    isFetching,
    dashboardType: DASHBOARD_TYPE.VIEWER_MODULE,
    dashboard: {},
    tempIsFetching: tempDashboard.isFetching,
  }),
);

const VMSavedDashboard = compose(
  connect(selectors, {
    initTempDashboard,
    initDashboard: vmSavedDashboardActions.initRequest,
    getDashboard: vmSavedDashboardActions.getDashboard,
    fetchingAction: vmSavedDashboardActions.fetching,
  }),
  dashboard(),
)(VMDashboard);

export default injectorServer(
  {},
  { pageType: PAGE_TYPE.SAVED_DASHBOARD },
)(VMSavedDashboard);
